import Dialog from './Dialog.vue'
import { merge } from '../../utils/helpers'
import { defineComponent, createApp, h } from 'vue'
import * as components from '../../components'
import i18n from '../../utils/i18n'

import {
  use,
  registerComponent,
  registerComponentProgrammatic,
} from '../../utils/plugins'

function open(params) {
  const container = document.createElement('div')
  let dialog

  params.onClose = () => {
    dialog.unmount()
  }

  const componentDefinition = defineComponent({
    setup: () => () => h(Dialog, { ...params }),
  })

  dialog = createApp(componentDefinition)

  Object.keys(components).forEach((i) => {
    registerComponent(dialog, components[i])
  })

  dialog.use(i18n)
  dialog.mount(container)
}

const DialogProgrammatic = {
  alert(params) {
    if (typeof params === 'string') {
      params = {
        message: params,
      }
    }
    const defaultParam = {
      programmatic: true,
      canCancel: false,
    }
    const propsData = merge(defaultParam, params)
    return open(propsData)
  },

  confirm(params) {
    const defaultParam = { programmatic: true }
    const propsData = merge(defaultParam, params)
    return open(propsData)
  },

  prompt(params) {
    const defaultParam = {
      programmatic: true,
      hasInput: true,
      confirmText: 'Done',
    }
    const propsData = merge(defaultParam, params)
    return open(propsData)
  },
}

const Plugin = {
  install(Vue) {
    registerComponent(Vue, Dialog)
    registerComponentProgrammatic(Vue, 'dialog', DialogProgrammatic)
  },
}

use(Plugin)

export default Plugin

export { DialogProgrammatic }
